import axios from "axios";
import TokenService from "./token.service";

// CRA replaces `process.env.REACT_APP_*` with a string literal at build time, so this
// resolves to the configured URL, or the stage-API fallback when the var is unset.
// Do NOT add a `typeof process !== "undefined"` guard: `process` is not a global in the
// browser bundle, so that guard is always false and would pin this to the fallback.
// Env options (set in .env / CI): https://fusion2.ornico.co.za (prod),
// https://stageapi.ornico.co.za (stage), http://localhost:3000 (local API).
const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://stageapi.ornico.co.za";

const instance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": "f3b96835356f78b4b3713466ee6dbe05"
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();
    if (token) {
      config.headers["Authorization"] = 'Bearer ' + token;  // for Spring Boot back-end
      // config.headers["x-access-token"] = token; // for Node.js Express back-end
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;

    if (originalConfig.url !== "/auth/signin" && err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          const rs = await instance.post("/users/refresh_token", {
            userId: TokenService.getUser().userId,
            refreshToken: TokenService.getLocalRefreshToken(),
          });

          TokenService.updateLocalAccessToken(rs.data);

          return instance(originalConfig);
        } catch (_error) {
          return Promise.reject(_error);
        }
      }
    }

    return Promise.reject(err);
  }
);

export default instance;
